module.exports = __webpack_public_path__ + "img/jd.24994608.png";